import type { RootState } from 'features/store/store';

export const selectDynamicTranslationsLanguage = (state: RootState) => {
  const value = state.dynamicTranslation.language;
  if (!value) {
    throw new Error(
      '[Assert failed] Attempt to rely on dynamic translations language but it is not available in store'
    );
  }
  return value;
};
